import React, { useMemo, useState, useRef } from 'react';
import { useNotify } from 'react-admin';
import {
  getEmptyReceivingSchedule,
  getSslList,
  getTerminalsList,
  getPortsList,
  SaveApiResMessage,
} from '@/actions';
import List from './List';
import styles from './styles';
import Add from './Add';
import LoadingV2 from '@/components/Loading';
import PageContainer from '@/components/PageContainerAB/pageContainer';
import IconButton from '@/ctComponents/IconButton';
import CustomSelectEx from '@/ctComponents/CustomSelectEx';
import ReceivableFilter from './ReceivableFilter';
import DateSelector from './DateSelector';
import { CustomFilter } from '@/components/Global';
import { fil } from 'date-fns/locale';
import { formatDateTimeToUTC } from '@/ctUtlis/formatDate';
import { fDate2 } from '@/actions/Helper';

export default (props) => {
  const cls = styles();
  const notify = useNotify();
  const [state, setState] = React.useState({
    edit: null,
    file: null,
  });
  const [pagination, setPagination] = React.useState({
    currentPage: 1,
    pages: [],
  });
  const [loading, setLoading] = React.useState(true);
  const [DATATable, setDataTable] = React.useState([]);
  const [DATADefault, setDATADefault] = React.useState([]);
  const [submitFilter, setSubmitFilter] = React.useState([]);
  const [sizeSelectOptions, setSizeSelectOptions] = useState(null);
  const [sslSelectOptions, setSslSelectOptions] = useState(null);
  const [selectedSIZE, setSelectedSize] = useState(null);
  const [selectedSSL, setSelectedSSL] = useState();
  const [PortsList, setPortsList] = useState({});
  const [selectedPort, setSelectedPort] = useState({
    label: 'Los Angeles / Long Beach',
    value: 0,
  });
  const [terminalsList, setTerminalsList] = useState([]);
  const [sslsList, setSslsList] = useState([]);
  const [filter, setFilter] = React.useState({
    open: false,
    DATA: [],
  });
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
  var yyyy = today.getFullYear();
  const dateFilterRef = useRef(null);
  today = { month: mm, day: dd, year: yyyy };

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const portSelectOptions = useMemo(
    () =>
      Object.keys(PortsList).map((i, index) => ({
        label: PortsList[index].name,
        slug: PortsList[index].slug,
        value: index + 1,
      })),
    [PortsList]
  );

  const hasAppliedFilters = () => {
    return (
      filter.appliedFilters &&
      Object.entries(filter.appliedFilters).filter(
        ([key, value]) => value && key !== 'vessel'
      ).length > 0
    );
  };

  const getEmptyReceivingScheduleList = () => {
    setLoading(true);
    getEmptyReceivingSchedule(`${today.year}-${today.month}-${today.day}`)
      .then((res) => {
        setDataTable(res.data.restrictions);
        const defaultData =
          res.data.default != null && typeof res.data.default === 'object'
            ? res.data.default
            : {};
        setDATADefault(defaultData);
        const sslSelectOptions = Object.keys(defaultData).map((i, index) => ({
          label: i,
          value: index + 1,
        }));
        setSslSelectOptions(sslSelectOptions);
        sslSelectOptions.unshift({ label: 'All', value: 0 });
        setSelectedSSL(sslSelectOptions[0]);
        const sizeSelectOptions = Object.keys(
          defaultData.ANL?.containers ?? {}
        ).map((i, index) => ({ label: i, value: index + 1 }));
        setSizeSelectOptions(sizeSelectOptions);
        sizeSelectOptions.unshift({ label: 'All', value: 0 });
        setSelectedSize(sizeSelectOptions[0]);
        setLoading(false);
      })
      .catch((err) => {
        // notify(err, 'warning');
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
        setLoading(false);
      });
  };

  const getPortsListFunc = () => {
    getPortsList()
      .then((res) => {
        const portsRes = Object.values(res.data.ports);
        if (portsRes) {
          setPortsList(portsRes);
        }
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const getTerminalsListFunc = () => {
    getTerminalsList()
      .then((res) => {
        const terminalsRes = Object.values(res.data.terminals);
        if (terminalsRes) {
          setTerminalsList(terminalsRes);
        }
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  const getSslListFunc = () => {
    getSslList()
      .then((res) => {
        const sslsRes = Object.values(res.data.ssl_list);
        if (sslsRes) {
          setSslsList(sslsRes);
        }
      })
      .catch((err) => {
        SaveApiResMessage({
          title: 'Error',
          message: err,
          mode: 'warning',
        });
      });
  };

  React.useEffect(() => {
    getEmptyReceivingScheduleList();
    getPortsListFunc();
    getTerminalsListFunc();
    getSslListFunc();
  }, [pagination.currentPage]);

  return (
    <PageContainer
      minWidth={'-webkit-fill-available'}
      title="Receivables"
      mainPage>
      <div className="">
        {/* Header Section */}
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-4 mt-6 mb-2">
          <div className="space-y-2">
            <h1 className="text-xl font-bold text-primary-text m-0">
              Terminal and Vessel Status Overview
            </h1>
            <p className="text-secondary-text text-lg m-0">
              View the latest updates on terminals Empty Receiving Schedules.
            </p>
          </div>

          <div className="flex flex-row gap-3 lg:justify-between lg:items-center my-1 lt570:flex-col lt570:items-center lt570:gap-2">
            <div className="w-64 lt570:w-full">
              <CustomSelectEx
                minHeight={40}
                dropdown
                isClearable
                placeholder="Select Port"
                value={selectedPort}
                onChange={setSelectedPort}
                options={portSelectOptions}
              />
            </div>
            {/* Date Filter */}
            <IconButton
              text="Filter"
              icon="filter"
              onClick={() => {
                setFilter({ ...filter, open: filter.open ? false : true });
              }}
              CustomClass="lt570:w-full"
              style={{
                height: '40px',
              }}
            />
            <IconButton
              text="Export XLSX"
              icon="exportXLSXIcon"
              color="#131517"
              CustomClass="lt570:w-full"
              style={{
                height: '40px',
              }}
              onClick={() => {}}
            />
          </div>
        </div>

        <CustomFilter
          filtersList={['size', 'ssl', 'date']}
          noTitleAndIcon={true}
          filter={filter}
          setFilter={setFilter}
          submitFilter={submitFilter}
          setSubmitFilter={setSubmitFilter}
          DATA={DATATable || []}
          sizeOptions={sizeSelectOptions}
          sslOptions={sslSelectOptions}
        />

        {hasAppliedFilters() && (
          <div className="relative z-99 w-full bg-white rounded-lg items-center flex flex-wrap gap-2 px-3 ">
            <span className="text-sm">Filtered by:</span>
            {Object.entries(filter.appliedFilters)
              .filter(
                ([key, value]) =>
                  value &&
                  key !== 'vessel' &&
                  key !== 'etd' &&
                  key !== 'erd' &&
                  key !== 'cutoff' &&
                  key !== 'date'
              )
              .map(([key, value]) => {
                return (
                  <div
                    key={key}
                    className="flex items-center gap-2 border border-solid border-inactive-text rounded-full px-2 py-0">
                    <span className="text-primary-text text-sm leading-5">
                      {value?.label}
                    </span>
                    <button
                      className="bg-transparent border-none text-border-gray-400 cursor-pointer text-lg font-bold p-0 hover:text-yellow-500"
                      onClick={() => {
                        const newFilters = { ...filter.appliedFilters };
                        delete newFilters[key];
                        setSubmitFilter({ ...newFilters });
                        setFilter({
                          ...filter,
                          appliedFilters: newFilters,
                        });
                      }}>
                      ×
                    </button>
                  </div>
                );
              })}
            {Object.entries(filter.appliedFilters)
              .filter(([key, value]) => value && key === 'date')
              .map(([key, value]) => {
                return (
                  <div
                    key={key}
                    className="flex items-center gap-2 border border-solid border-inactive-text rounded-full py-0 px-2">
                    <span className="text-primary-text text-sm leading-5">
                      {fDate2(value)}
                    </span>
                    <button
                      className="bg-transparent border-none text-border-gray-400 cursor-pointer text-lg font-bold p-0 hover:text-yellow-500"
                      onClick={() => {
                        const newFilters = { ...filter.appliedFilters };
                        delete newFilters[key];
                        setSubmitFilter({ ...newFilters });
                        setFilter({
                          ...filter,
                          appliedFilters: newFilters,
                        });
                        if (key === 'date') {
                          getEmptyReceivingScheduleList();
                        }
                      }}>
                      ×
                    </button>
                  </div>
                );
              })}
          </div>
        )}

        <Add
          notify={notify}
          DATATable={DATATable}
          DATADefault={DATADefault}
          setData={(res) => {
            setFilter({ ...filter, DATATable });
          }}
        />

        {loading ? (
          <div className="mt-16">
            <LoadingV2 />
          </div>
        ) : (
          <List
            DATA={DATATable}
            TerminalList={DATATable}
            DATADefault={DATADefault}
            submitFilter={submitFilter}
          />
        )}
      </div>
    </PageContainer>
  );
};
